import { GetInsurerInformationTabsQueryParams } from '@/modules/adjusterReportModules/Insurer-information/queries/getInsurerInformationTabs/getInsurerInformationTabs.type';
import { getInsurerInformationTabsQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getInsurerInformationTabs/getParticipantsTabsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getInsurerInformationTabsQueryOptions = (
  params: GetInsurerInformationTabsQueryParams,
) =>
  queryOptions({
    queryKey: ['get_insurer_information_tabs', params],
    queryFn: () => getInsurerInformationTabsQueryFunction(params),
  });
